import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  sectionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '50px'
  }
}));
